import Emitter from 'tiny-emitter';

export const EventBus = new Emitter();